import { render, staticRenderFns } from "./editMessage.vue?vue&type=template&id=5f462466&scoped=true"
import script from "./editMessage.vue?vue&type=script&lang=js"
export * from "./editMessage.vue?vue&type=script&lang=js"
import style0 from "./editMessage.vue?vue&type=style&index=0&id=5f462466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f462466",
  null
  
)

export default component.exports